module.exports = __webpack_public_path__ + "static/media/SupportGuide.9afaad59.pdf";